import type { Pose } from './Pose';

/** Where on a segment a connector sits. IN is the single entry; all others are exits. */
export const ConnectorRole = {
  In: 'IN',
  Out: 'OUT',
  Left: 'LEFT',
  Right: 'RIGHT',
} as const;
export type ConnectorRole = (typeof ConnectorRole)[keyof typeof ConnectorRole];

/**
 * Geometric interface of a connector ("plug type"). Two segments may only be
 * joined if the exit allows the entry's profile – e.g. a future elevated
 * scaffold track cannot snap onto a ground-level track.
 */
export const ConnectorProfile = {
  /** 3 lanes × 2.2 m = 6.6 m, ground level. */
  Ground3Lane: 'TRACK_GROUND_3LANE',
} as const;
export type ConnectorProfile = (typeof ConnectorProfile)[keyof typeof ConnectorProfile];

export interface ConnectorDefinition {
  /** Matches the Blender empty name: CONNECTOR_IN, CONNECTOR_OUT, CONNECTOR_LEFT, CONNECTOR_RIGHT. */
  readonly id: string;
  readonly role: ConnectorRole;
  readonly profile: ConnectorProfile;
  /**
   * Segment-local transform: position on the track centerline at ground
   * height, yaw = direction of travel when passing through the connector.
   */
  readonly transform: Pose;
  /** Entry profiles a following segment may have (exits only). */
  readonly allowedNextProfiles: readonly ConnectorProfile[];
}
